import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../hooks/useEmployee";
import useNas from "../../../hooks/useNas";
import useBranch from "../../../hooks/useBranch";
import usePlan from "../../../hooks/usePlan";

import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../utils/common";
import { OperatorConstants } from "../../../constants/operator.constants";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    userNameOperator: "eq",

    planIdOperator: "eq",

    planId: [],

    userName: "",
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  console.log(payload, "payload9090");

  const { autoSearchPlan, planAutoSearchResults, isLoadingAutoSearch } = usePlan();

  const [planPayload, setPlanPayload] = useState(currentPayload);
  const [planOptions, setPlanOptions] = useState([]);
  const [planMultiValue, setPlanMultiValue] = useState(false);
  const [defaultPlan, setDefaultPlan] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const planOpValue = watch("planIdOperator");

  const onSubmit = async (data) => {
    try {
      let filters = payload["filters"];
      console.log(payload, "565463635");

      if (data.userName != null && Object.keys(data.userName).length != 0) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: data.userNameOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.planId != null && Object.keys(data.planId).length != 0) {
        filters.push({
          fieldName: "planId",
          fieldValue: convertedValue(data.planId, "value").join(","),
          op: data.planIdOperator,
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (planOpValue == "in" || planOpValue == "nin") {
      setDefaultPlan([]);
      setValue("planId", []);
      setPlanMultiValue(true);
    } else {
      setDefaultPlan({});
      setValue("planId", {});
      setPlanMultiValue(false);
    }
  }, [planOpValue]);

  const fetchPlan = async () => {
    await autoSearchPlan(planPayload);
  };
  useEffect(() => {
    fetchPlan();
  }, [planPayload]);

  useEffect(() => {
    if (planAutoSearchResults.data.length !== 0) {
      const results = [...planOptions, ...planAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setPlanOptions(filteredResults);
    }
  }, [planAutoSearchResults]);

  const searchPlanInputChange = (data) => {
    console.log(data, "searchInputChange");
    let filters = [];
    filters.push({
      fieldName: "planId",
      fieldValue: data,
      op: "like",
      dataType: "string",
      condition: "and",
      isJoin: false,
    });
    setPlanPayload({
      ...planPayload,
      filters: filters,
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
    });
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} pt={8}>
            <Grid item md={2} sm={6}>
              <ReactHookFormSelect
                name="userNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={4} sm={6} xs={8}>
              <CustomTextField
                label={t("user_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>

            <Grid item xs={4} sm={6} md={2}>
              <ReactHookFormSelect
                name="planIdOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={8} sm={6} md={4}>
              <SearchableAutoComplete
                control={control}
                data={planOptions}
                label="Plan Name"
                payload={planPayload}
                setPayload={setPlanPayload}
                loading={isLoadingAutoSearch}
                name="planId"
                multiple={planMultiValue}
                defaultValue={defaultPlan}
                searchInputChange={searchPlanInputChange}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
